import React from 'react';
import {Routes, Route} from "react-router-dom";

//routes
import Login from './pages/Login'
import Landing from './pages/Landing'
import StudyInformation from './pages/StudyInformation'
import StudyInformation2 from './pages/StudyInformation2'
import EnrollmentType from './pages/EnrollmentType'
import Contact from './pages/Contact'
import OnlineEnrollment from './pages/OnlineEnrollment'
import ContactSuccess from './pages/ContactSuccess'
import EligibilityAssessment from './pages/EligibilityAssessment'
import Layout from './layout'

const publicRoutes = [
    {path: "/", component: <Landing/>},
    {path: "/study-information", component: <StudyInformation/>},
    {path: "/study-information-2", component: <StudyInformation2/>},
    {path: "/enrollment-type", component: <EnrollmentType/>},
    {path: "/guided-enrollment", component: <Contact/>},
    {path: "/online-enrollment", component: <OnlineEnrollment/>},
    {path: "/eligibility-assessment", component: <EligibilityAssessment/>},
    {path: "/contact-success", component: <ContactSuccess/>},
    {path: "/login", component: <Login/>},
]
const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <Layout>
                                {route.component}
                            </Layout>}
                        key={idx}
                        exact={true}
                    />
                ))}
            </Routes>
        </React.Fragment>
    );
};

export default Index;
